import { render } from "./PediatricGrowthChart.vue?vue&type=template&id=69aa738c&scoped=true"
import script from "./PediatricGrowthChart.vue?vue&type=script&lang=js"
export * from "./PediatricGrowthChart.vue?vue&type=script&lang=js"

import "./PediatricGrowthChart.vue?vue&type=style&index=0&id=69aa738c&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69aa738c"]])

export default __exports__